import { Link } from "react-router-dom";
import { useAppSelector } from "../app/hooks";
import logo from "../assets/logoTransparent.png";
import { userLoggedIn } from "../pages/login/loginSlice";
import AccountMenu from "./AccountMenu";
import "./Header.scss";

function Header() {
    const isLoggedIn = useAppSelector(userLoggedIn);
    return(<header>
        <Link to="/">
            <picture className={"headerLogo"}>
                <img src={logo} alt="Oh No! Not Another Email Client" />
            </picture>
        </Link>
        {isLoggedIn && <AccountMenu />}
    </header>)
}

export default Header;